var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4996 1.92786V3.35008M14.5279 4.01065L13.5223 5.01632M16.6107 9.03895H15.1885M14.5279 14.0673L13.5223 13.0616M9.4996 14.7279V16.1501M5.47695 13.0616L4.47129 14.0673M3.81077 9.03903H2.38855M5.47693 5.01637L4.47126 4.01071M12.344 9.03897C12.344 10.6099 11.0705 11.8834 9.4996 11.8834C7.92866 11.8834 6.65516 10.6099 6.65516 9.03897C6.65516 7.46802 7.92866 6.19452 9.4996 6.19452C11.0705 6.19452 12.344 7.46802 12.344 9.03897Z",
    stroke: "#F9A8A8",
    strokeWidth: 1.06667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.79be8e539819bef737d70c02f0fc5f7f.svg";
export { ForwardRef as ReactComponent };